import { useEffect, useRef, useState } from "react";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  TitleWrapper,
  LegislationDetailContainer,
  ContentWrapper,
  BackToGuidesWrapper,
  NoDataContainer,
  SvgContainer,
  IFrameContainer,
} from "./LegislationEventsStyled";

// LIBRARIES
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//ASSETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// MISC
import { COLORS } from "constants/variables";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { appRoutes } from "config/AppRoutesConfig";
import { DownloadFileType } from "components/Atoms/DownloadFileAtom/DownloadFileAtomModel";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import HeaderTab from "components/HeaderTab/HeaderTab";
import DownloadFileAtom from "components/Atoms/DownloadFileAtom/DownloadFileAtom";
import Preloader from "components/Atoms/Lotties/Preloader";
import Pagination from "components/Atoms/Paginations/Pagination";

// HOOKS
import usePagination from "hooks/usePagination";
import newsAndMediaService from "services/newsAndMediaService";
import { PreloaderWrapper } from "view/Map/MapStyled";

const LegislationEvents = () => {
  // PROPERTIES
  const ELEMENTS_PER_PAGE = 15;

  // API REQUESTS

  // LIBRARY CONSTANTS
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();
  const topRef = useRef(null);

  // STATE CONSTANTS
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [legislations, setLegislations] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsLoading(true);
    newsAndMediaService
      .getLegislationMajorEvents()
      .then((response) => {
        // console.log("legislations resp", response);
        setLegislations(response);
      })
      .catch((err) => {
        console.error(err);
      });
    setIsLoading(() => false);
  }, []);

  const tabData =
    legislations?.data?.map((item) => ({
      id: item.id,
      content: item?.attributes?.documents?.data || [],
    })) || [];

  const tabs = legislations?.data?.length
    ? legislations.data.map((item) => ({
        id: item.id,
        tabTitle: item?.attributes?.country_name || "Untitled",
      }))
    : [];

  const { currentPage, totalPages, currentData, handlePageChange } =
    usePagination(
      tabData[selectedTab]?.content || [],
      ELEMENTS_PER_PAGE,
      topRef
    );

  const content =
    currentData && currentData.length > 0 ? (
      <ContentWrapper>
        {currentData.map((article) => {
          return (
            <DownloadFileAtom
              key={article.id}
              type={DownloadFileType.Orders}
              title={article.attributes?.title}
              date={article.attributes?.createdAt}
              institution={article.institution}
              pdfUrl={`${process.env.REACT_APP_UPLOAD_URL}${article?.attributes?.attached_document?.data?.attributes?.url}`}
            />
          );
        })}
      </ContentWrapper>
    ) : (
      <NoDataContainer>
        <SvgContainer>
          <NoDataDark />
        </SvgContainer>
        <CustomText
          text={t("app.noData")}
          type={TextType.P1}
          color={COLORS.MetalicSilver}
        />
      </NoDataContainer>
    );
  // LIFE CYCLE

  // EVENT HANDLERS
  const handleTabSelect = (selectedTabId) => {
    if (tabData && tabData.length > 0) {
      const index = tabData.findIndex((tab) => tab.id === selectedTabId);
      if (index !== -1) {
        setSelectedTab(index);
      }
    }
  };

  return (
    <>
      {!isLoading ? (
        <LegislationDetailContainer ref={topRef}>
          <BackToGuidesWrapper
            biggerCursor={biggerCursor}
            onClick={() => navigate(appRoutes.legislation)}
          >
            <BackToGuidesImage src={LeftArrow} alt="backIcon" />
            <BackToGuidesButton>
              <CustomText
                text={t("view.legislationDetail.button")}
                type={TextType.H5boldspaced}
                color={COLORS.RaisinBlack}
              />
            </BackToGuidesButton>
          </BackToGuidesWrapper>
          <TitleWrapper>
            <CustomText
              type={TextType.H2}
              text={t("view.legislationEvents.title")}
            />
          </TitleWrapper>
          <HeaderTab tabs={tabs} onTabSelect={handleTabSelect} />
          {content}
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
          <IFrameContainer>
            <iframe
              src="https://form.typeform.com/to/yLrfAz6G?typeform-embed-id=08258747599055072&amp;typeform-embed=embed-widget&amp;typeform-source=dsu.mai.gov.ro&amp;typeform-medium=snippet&amp;typeform-medium-version=next&amp;embed-opacity=100&amp;typeform-embed-handles-redirect=1&amp;typeform-embed-no-heading=true"
              data-testid="iframe"
              allow="microphone; camera"
              title="Integrare Refugiați Ucraineni"
            ></iframe>
          </IFrameContainer>
        </LegislationDetailContainer>
      ) : (
        <PreloaderWrapper>
          <Preloader width={100} height={100} />
        </PreloaderWrapper>
      )}
    </>
  );
};

export default LegislationEvents;
